<template src="./MensajesMasivos.html"></template>

<script>
import moment from "moment-timezone";
const moment_tz = require("moment-timezone");
import { leerLista, readSchemes } from "../../apiService/request/CrudTerapias";
import {
  optionsTemplate,
  parametersTemplate,
  sendMassNotifications,
  urlTemplate,
  getFiles,
} from "../../apiService/request/crudMendajes";
import TextMessage from "./TextMessage/TextMessage";
import PushMessage from "./PushMessage/PushMessage";
export default {
  data() {
    return {
      therapyListItem: [],
      therapySelected: "",
      reglaObligatorioTherapy: [(v) => !!v || "Selecciona una terapia"],
      reglaObligatorioScheme: [
        (v) => !!v || "Selecciona una o varias plantillas",
      ],
      reglaObligatorioStateTherapy: [
        (v) => !!v || "Selecciona una o varios estados",
      ],
      schemesItems: [],
      schemesSelected: [],
      stateItems: [],
      stateSelected: [],
      templateOptions: [],
      itemsTemplateSelected: "",
      dataTextBody: "",
      parametersTemplate: [],
      type: "",
      name: null,
      templateSelected: "",
      urlItems: [],
      viewUrlList: false,
      itemsTemplate: [],
      dialog: false,
      urlSelected: "",
      menu: false,
      options: {
        locale: "es",
        format: "DD-MM-YYYY",
        clearable: false,
      },
      menu4: false,
      hourSelected: "",
      selectedParameters: [],
      indexBody: {},
      dataBody: "",
      copySelectedParameters: [],
      seeSms: false,
      seePush: false,
      seeWhatsAppMessages: false,
      seeNotificationpush: false,
      messageType: [],
      channels: [],
      traslate: {
        whatsapp: "whatsapp",
        mensajedetexto: "sms",
        notificaciónpush: "push",
      },
      dataMessage: {},
      messageTypeItems: [],
      dataToMessage: {},
      translate: {
        imagen: "image",
        video: "video",
        audio: "audio",
        texto: "text",
        ubicacion: "location",
        documento: "document",
        file: null,
        audio: null,
        title: null,
        image: null,
        video: null,
      },
    };
  },
  created() {
    this.getListTherapys();
  },
  computed: {
    enabledBtn() {
      this.copySelectedParameters = [];
      this.copySelectedParameters = this.selectedParameters.filter(
        (e) => e !== undefined
      );
      if (
        this.parametersTemplate.length > 0 &&
        this.parametersTemplate.length === this.copySelectedParameters.length
      ) {
        return true;
      } else {
        return false;
      }
    },
  },
  methods: {
    cancel() {
      this.limpiarData();
    },
    limpiarData() {
      this.file = null;
      this.audio = null;
      this.title = null;
      this.image = null;
      this.video = null;
      this.dataMessage = {};
      this.messageTypeItems = [];
      this.dataToMessage = {};
      this.menu4 = false;
      this.hourSelected = "";
      this.selectedParameters = [];
      this.indexBody = {};
      this.dataBody = "";
      this.copySelectedParameters = [];
      this.seeSms = false;
      this.seePush = false;
      this.seeWhatsAppMessages = false;
      this.seeNotificationpush = false;
      this.messageType = [];
      this.channels = [];
      this.therapySelected = "";
      this.schemesItems = [];
      this.schemesSelected = [];
      this.stateItems = [];
      this.stateSelected = [];
      this.templateOptions = [];
      this.itemsTemplateSelected = "";
      this.dataTextBody = "";
      this.parametersTemplate = [];
      this.type = "";
      this.name = null;
      this.templateSelected = "";
      this.urlItems = [];
      this.viewUrlList = false;
      this.itemsTemplate = [];
      this.urlSelected = "";
    },
    async sendInfoMessage(event) {
      this.dataMessage = event;
      this.dataMessage["phone"] = null;
      this.dataMessage["creado_por"] = this.$store.state.provider_email;
      let response = null;
      try {
        response = await sendMassNotifications(
          this.schemesSelected,
          this.therapySelected,
          this.stateSelected,
          this.dataMessage,
          this.channels
        );
      } catch (error) {
        console.log(error);
      } finally {
        this.messageType = [];
        this.seeWhatsAppMessages = false;
        this.seeSms = false;
        this.seePush = false;
        alert(response.data.message);
        this.limpiarData();
        this.$store.dispatch("setCargando", false);
      }
    },
    sendData() {
      this.$store.dispatch("setCargando", true);
      try {
        if (confirm("¡Está seguro de enviar este mensaje!")) {
          this.dataToMessage = {
            template: this.name === null ? "no_aplica" : this.name,
            code: "57",
            params: this.selectedParameters,
            type: this.type,
            body: this.dataBody,
            file: this.file,
            audio: this.audio,
            title: this.title ? this.title : this.titlePush,
            image: this.image,
            video: this.video,
          };
          this.sendInfoMessage(this.dataToMessage);
        } else {
          this.$store.dispatch("setCargando", false);
        }
      } catch (error) {
        console.log(error);
      }
    },
    async searchList() {
      try {
        this.$store.dispatch("setCargando", true);
        const respuesta = await leerLista("opciones_mensajes");
        if (respuesta && respuesta.data && respuesta.data.data) {
          this.messageTypeItems = respuesta.data.data;
        }
      } catch (err) {
        console.log(err);
      } finally {
        this.$store.dispatch("setCargando", false);
      }
    },
    checkType() {
      this.itemsTemplateSelected = "";
      this.seeSms = false;
      this.seePush = false;
      this.seeWhatsAppMessages = false;
      this.seeNotificationpush = false;
      this.templateOptions = [];
      this.itemsTemplate = [];
      this.templateSelected = "";
      this.urlItems = [];
      this.viewUrlList = false;
      if (this.messageType.includes("WhatsApp")) {
        if (this.messageType.includes("Notificación push")) {
          this.seeNotificationpush = true;
        }
        this.seeWhatsAppMessages = true;
        this.seeSms = false;
      } else if (
        this.messageType.includes("Mensaje de texto") &&
        !this.messageType.includes("Notificación push")
      ) {
        if (this.messageType.includes("Notificación push")) {
          this.seeNotificationpush = true;
        }
        this.seeWhatsAppMessages = false;
        this.seeSms = true;
      } else if (this.messageType.includes("Notificación push")) {
        if (this.messageType.includes("Mensaje de texto")) {
          this.seeSms = false;
        }
        this.seeWhatsAppMessages = false;
        this.seeSms = false;
        this.seePush = true;
      }
      this.listTempalte();
    },
    lowerCaseSelected() {
      this.templateOptions = [];
      this.parametersTemplate = [];
      let nuevoarr = [];
      this.channels = [];
      this.messageType
        .map((e, i) => {
          this.channels[i] = this.traslate[e.toLowerCase().replace(/\s+/g, "")];
        })
        .push(this.traslate[nuevoarr]);
    },
    variableName() {
      this.parametersTemplate.forEach((e, i) => {
        if (e.parameter == "Nombre") {
          this.selectedParameters[i] = "{{1}}";
        }
      });
    },
    changeDataBody(numOrder, i, text) {
      this.selectedParameters = [];
      this.indexBody[numOrder] = text;
      this.dataBody = this.dataTextBody;
      Object.keys(this.indexBody).forEach((e) => {
        const to_replacer = `{{${e}}}`;
        this.dataBody = this.dataBody.replace(to_replacer, this.indexBody[e]);
        if (this.indexBody[e] !== "") {
          this.selectedParameters[e - 1] = this.indexBody[e];
        }
      });
      this.variableName();
    },
    chabgeDate(date, i) {
      this.menu = false;
      let myDate = moment(date).format("DD/MM/YYYY");
      this.selectedParameters[i] = myDate;
    },
    selectHour(i) {
      this.selectedParameters[i] = moment(this.hourSelected, "hh:mm A").format(
        "hh:mm A"
      );
    },
    async searchStructureParameters() {
      this.$store.dispatch("setCargando", true);
      this.parametersTemplate = [];
      this.selectedParameters = [];
      this.indexBody = [];
      this.dataBody = "";
      let response = null;
      try {
        response = await parametersTemplate(this.itemsTemplateSelected);
        this.dataTextBody = response.data.data.data[0].data;
        this.parametersTemplate = response.data.data.data[0].parameters;
        this.type = response.data.data.data[0].type.toLowerCase();
        this.name = response.data.data.data[0].name;
      } catch (error) {
        console.log(error);
      } finally {
        this.variableName();
        this.changeDataBody();
        this.$store.dispatch("setCargando", false);
      }
    },
    asingUrlSelected() {
      if (this.templateSelected === "Imagen") {
        this.image = this.urlSelected;
      } else if (this.templateSelected === "Video") {
        this.video = this.urlSelected;
      } else if (this.templateSelected === "Documento") {
        this.file = this.urlSelected;
        const titleSelected = this.urlItems.find(
          (e) => e.nombre === this.urlSelected
        );
        this.title = titleSelected.valor;
      }
    },
    async searchListUrl() {
      this.urlItems = [];
      try {
        this.viewUrlList = true;
        const searchList = this.templateSelected;
        if (searchList !== "Texto") {
          const response = await urlTemplate(searchList);
          this.urlItems = response.data.data.option;
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.$store.dispatch("setCargando", false);
      }
    },
    async searchTemplate() {
      this.$store.dispatch("setCargando", true);
      this.dataBody = "";
      this.parametersTemplate = [];
      this.selectedParameters = [];
      this.itemsTemplate = [];
      this.urlSelected = "";
      this.urlItems = [];
      this.itemsTemplateSelected = "";
      let response = null;
      try {
        if (this.templateSelected !== "Texto") {
          await this.searchListUrl();
        }
        response = await optionsTemplate(this.templateSelected);
        this.itemsTemplate = response.data.data;
      } catch (error) {
        console.log(error);
      } finally {
        this.$store.dispatch("setCargando", false);
      }
    },
    async listTempalte() {
      try {
        this.$store.dispatch("setCargando", true);
        const respuesta = await leerLista("opciones_template");
        if (respuesta && respuesta.data && respuesta.data.data) {
          this.templateOptions = respuesta.data.data;
        }
      } catch (err) {
        console.log(err);
      } finally {
        this.$store.dispatch("setCargando", false);
      }
    },
    async getStateTherapys() {
      try {
        this.$store.dispatch("setCargando", true);
        const response = await leerLista("estado_terapias_masivos");
        if (response && response.data && response.data.data) {
          this.stateItems = response.data.data;
        }
      } catch (err) {
        console.log(err);
      } finally {
        this.$store.dispatch("setCargando", false);
      }
    },
    async getSchemesItems() {
      this.schemesSelected = "";
      this.schemesItems = [];
      this.stateSelected = "";
      this.stateItems = [];
      this.messageType = "";
      this.messageTypeItems = [];

      try {
        this.$store.dispatch("setCargando", true);
        const respuesta = await readSchemes(this.therapySelected);
        if (respuesta && respuesta.data && respuesta.data.data) {
          this.schemesItems = respuesta.data.data;
        }
      } catch (err) {
        console.log(err);
      } finally {
        this.$store.dispatch("setCargando", false);
      }
    },
    async getListTherapys() {
      try {
        this.$store.dispatch("setCargando", true);
        const response = await leerLista("terapias_planb");
        if (response && response.data && response.data.data) {
          this.therapyListItem = response.data.data;
        }
      } catch (err) {
        console.log(err);
      } finally {
        this.$store.dispatch("setCargando", false);
      }
    },
  },
  components: {
    TextMessage,
    PushMessage,
  },
};
</script>

<style lang="scss" scoped src="./MensajesMasivos.scss">
</style>


// WEBPACK FOOTER //
// src/components/MensajesMasivos/MensajesMasivos.vue